module.exports = __webpack_public_path__ + "img/82c1607a16d7b327f044370fd5545664.f78edb7f.png";